import React from 'react';
import MarkFavGame from './MarkFavGame';
import useTranslate from '../../hooks/useTranslate';

const GameCard = ({ id, type, imageURL, title, onClick, style, className }) => {
    const t = useTranslate();
    const translatedTitle = t(title, {}, title);
    return (
        <div className="game-card-page">
            <div className="game-card-img" onClick={onClick}>
                <img src={imageURL} alt={translatedTitle} />
                <p className="game-title">{translatedTitle}</p>
            </div>
            <MarkFavGame id={id} />
        </div>
    );
};

export default GameCard;
